import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { AppInsightsService } from "~app/common/services/app-insights.service";
import { DefaultHeaderInterceptor } from "./default-header.interceptor";
import { DefaultHeaderService } from "./default-header.service";

@NgModule({
    declarations: [],
    providers:[
        { provide: "AppInsightsService",
            useExisting: AppInsightsService },
        { provide: "DefaultHeaderService",
            useExisting: DefaultHeaderService  },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: DefaultHeaderInterceptor,
            multi: true
        }
    ],
    imports: []
})
export class SeleniumModule { }
